// import Cookies from 'js-cookie'

const TOKEN_KEY = 'ZPACE_TOKEN'

// export function getToken () {
//   return Cookies.get(TOKEN_KEY)
// }

// export function setToken (token) {
//   return Cookies.set(TOKEN_KEY, token)
// }

// export function removeToken () {
//   return Cookies.remove(TOKEN_KEY)
// }

export function getToken () {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken (token) {
  return localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken () {
  return localStorage.removeItem(TOKEN_KEY)
}

export function getStorage (key) {
  return localStorage.getItem(key)
}

export function setStorage (key, val) {
  return localStorage.setItem(key, val)
}

export function removeStorage (key) {
  return localStorage.removeItem(key)
}

export function removeAllStorge () {
  return localStorage.clear()
}
